import type { ReactNode } from 'react';
import { Download, RotateCcw } from 'lucide-react';

/**
 * Barre de filtres d'une liste, son bouton d'export à droite : la vue globale
 * de la direction (TF-426), le pilotage par financeur (TF-428) et le journal
 * d'audit (TF-438). Sans export, le tableau de bord de satisfaction (TF-433).
 */
export function BarreFiltres({
  children,
  onReinitialiser,
  onExporter,
  exportEnCours,
  libelleExport = 'Exporter (Excel)',
}: {
  children: ReactNode;
  onReinitialiser: (() => void) | null;
  onExporter?: () => void;
  exportEnCours?: boolean;
  /** « Exporter » quand le format se choisit ensuite (journal d'audit, TF-438). */
  libelleExport?: string;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-3 rounded-2xl bg-white p-3 shadow-card sm:p-4 xl:flex-row xl:items-start xl:justify-between">
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
        {children}
        {onReinitialiser && (
          <button
            type="button"
            onClick={onReinitialiser}
            className="inline-flex min-h-[44px] items-center gap-1.5 rounded-lg px-3 text-xs font-semibold text-codialis-sky hover:underline"
          >
            <RotateCcw className="h-3.5 w-3.5" aria-hidden />
            Réinitialiser
          </button>
        )}
      </div>
      {onExporter && (
        <button
          type="button"
          onClick={onExporter}
          disabled={exportEnCours}
          className="inline-flex min-h-[44px] shrink-0 items-center justify-center gap-2 rounded-xl bg-codialis-navy px-4 text-sm font-semibold text-white transition hover:bg-codialis-deep disabled:opacity-60"
        >
          <Download className="h-4 w-4" aria-hidden />
          {exportEnCours ? 'Export…' : libelleExport}
        </button>
      )}
    </div>
  );
}
